<template>
  <div class="container mt-4">
    <button @click="goBack" class="btn btn-secondary mb-3">
      <font-awesome-icon icon="arrow-left" /> Zurück zur Übersicht
    </button>
    <h2 class="text-center">Artikel für Kunden hinzufügen</h2>

    <!-- Kundensuche -->
    <div class="form-group">
      <label for="customerSearch">Kunden suchen</label>
      <input
        type="text"
        v-model="customerQuery"
        @input="searchCustomers"
        placeholder="Kunden suchen"
        class="form-control"
      />
      <ul v-if="customerResults.length">
        <li
          v-for="customer in customerResults"
          :key="customer.id"
          @click="selectCustomer(customer)"
        >
          {{ customer.FirstName }} {{ customer.LastName }} (ID: {{ customer.id }})
        </li>
      </ul>
    </div>

    <!-- Anzeige der Artikel, wenn Kunde ausgewählt -->
    <div v-if="selectedCustomer">
      <h4>Artikel für {{ selectedCustomer.FirstName }} {{ selectedCustomer.LastName }}</h4>

      <table class="table">
        <thead>
          <tr>
            <th>Artikelnummer</th>
            <th>Name</th>
            <th>Farbe</th>
            <th>Größe</th>
            <th>Geschlecht</th>
            <th>Erhalten am</th>
            <th>Verkaufspreis</th>
            <th>Kommentare</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(article, index) in articles" :key="index">
            <td>{{ article.ArticleNumber }}</td>
            <td>
              <input v-model="article.Name" placeholder="Name" class="form-control" />
            </td>
            <td>
              <input v-model="article.Color" placeholder="Farbe" class="form-control" />
            </td>
            <td>
              <input v-model="article.Size" placeholder="Größe" class="form-control" />
            </td>
            <td>
              <input v-model="article.Gender" placeholder="Geschlecht" class="form-control" />
            </td>
            <td>
              <input
                type="date"
                v-model="article.ReceivedDate"
                @change="updateDefaultDate(article.ReceivedDate)"
                class="form-control"
              />
            </td>
            <td>
              <input
                type="number"
                step="0.01"
                v-model="article.SalePrice"
                placeholder="CHF"
                class="form-control"
              />
            </td>
            <td>
              <textarea
                v-model="article.Comment"
                placeholder="Kommentare"
                class="form-control"
              ></textarea>
            </td>
            <td>
              <button @click="removeArticle(index)" class="btn btn-danger btn-sm">-</button>
            </td>
          </tr>
        </tbody>
      </table>

      <button @click="addArticle" class="btn btn-primary">+ Artikel hinzufügen</button>
      <button @click="saveArticles" class="btn btn-success">Speichern</button>
    </div>
  </div>
</template>

<script>
import axios from '@/services/axios';

export default {
  data() {
    return {
      customerQuery: '',
      customerResults: [],
      selectedCustomer: null,
      articles: [],
      nextArticleNumber: null,
      // Default-Datum für ReceivedDate
      defaultReceivedDate: new Date().toISOString().substr(0, 10),
    };
  },
  methods: {
    async searchCustomers() {
      if (this.customerQuery.length > 2) {
        try {
          const response = await axios.get(`/customers?search=${this.customerQuery}`);
          this.customerResults = response.data;
        } catch (error) {
          console.error('Fehler bei der Kundensuche:', error);
        }
      }
    },

    selectCustomer(customer) {
      this.selectedCustomer = customer;
      this.customerResults = [];
      this.fetchNextArticleNumber();
      this.articles = [];
    },

    async fetchNextArticleNumber() {
      try {
        const response = await axios.get('/articles/next-number');
        this.nextArticleNumber = response.data.nextArticleNumber;
      } catch (error) {
        console.error('Fehler beim Abrufen der nächsten Artikelnummer:', error);
      }
    },

    addArticle() {
      if (this.nextArticleNumber !== null) {
        this.articles.push({
          Name: '',
          Color: '',
          Size: '',
          Gender: '',
          SalePrice: null,
          Comment: '',
          // Setze ReceivedDate auf das Default-Datum
          ReceivedDate: this.defaultReceivedDate,
          ArticleNumber: this.nextArticleNumber,
          isMarkedForReturn: false
        });
        this.nextArticleNumber += 1;
      } else {
        console.warn('Nächste Artikelnummer ist nicht definiert.');
      }
    },

    removeArticle(index) {
      this.articles.splice(index, 1);
    },

    /**
     * Aktualisiert das Default-Datum, wenn der Benutzer in einer Zeile manuell ändert.
     */
    updateDefaultDate(newDate) {
      this.defaultReceivedDate = newDate;
    },

    async saveArticles() {
      try {
        await axios.post('/articles/bulk', {
          Customerid: this.selectedCustomer.id,
          articles: this.articles,
        });
        this.$router.push('/items');
      } catch (error) {
        console.error('Fehler beim Speichern der Artikel:', error);
      }
    },

    goBack() {
      this.$router.push('/items');
    },
  },
  created() {
    // Optional: falls direkt mit Artikelnummern gestartet werden soll, hier fetchNextArticleNumber aufrufen
  },
};
</script>

<style scoped>
.table {
  margin-top: 20px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  cursor: pointer;
  padding: 5px;
}

li:hover {
  background-color: #f0f0f0;
}
</style>
